// @ts-nocheck
import * as Types from '../../../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ApplyInitialConfigurationGateQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type ApplyInitialConfigurationGateQuery = { __typename?: 'Query', structure: { __typename?: 'Structure', id: string, hasStartedConstruction: boolean, commitments: Array<{ __typename?: 'Commitment', id: string, status: Types.CommitmentStatus, committedInCents: number, canBeVoided: { __typename?: 'PotentialOperation2', allowed: boolean } }> } };

export type ApplyInitialConfigurationGate_StructureFragment = { __typename?: 'Structure', id: string, hasStartedConstruction: boolean, commitments: Array<{ __typename?: 'Commitment', id: string, status: Types.CommitmentStatus, committedInCents: number, canBeVoided: { __typename?: 'PotentialOperation2', allowed: boolean } }> };

export const ApplyInitialConfigurationGate_StructureFragmentDoc = gql`
    fragment ApplyInitialConfigurationGate_Structure on Structure {
  id
  hasStartedConstruction
  commitments {
    id
    status
    committedInCents
    canBeVoided {
      allowed
    }
  }
}
    `;
export const ApplyInitialConfigurationGateDocument = gql`
    query ApplyInitialConfigurationGate($projectId: ID!) {
  structure(id: $projectId) {
    ...ApplyInitialConfigurationGate_Structure
  }
}
    ${ApplyInitialConfigurationGate_StructureFragmentDoc}`;

/**
 * __useApplyInitialConfigurationGateQuery__
 *
 * To run a query within a React component, call `useApplyInitialConfigurationGateQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplyInitialConfigurationGateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplyInitialConfigurationGateQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useApplyInitialConfigurationGateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ApplyInitialConfigurationGateQuery, ApplyInitialConfigurationGateQueryVariables> & ({ variables: ApplyInitialConfigurationGateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ApplyInitialConfigurationGateQuery, ApplyInitialConfigurationGateQueryVariables>(ApplyInitialConfigurationGateDocument, options);
      }
export function useApplyInitialConfigurationGateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ApplyInitialConfigurationGateQuery, ApplyInitialConfigurationGateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ApplyInitialConfigurationGateQuery, ApplyInitialConfigurationGateQueryVariables>(ApplyInitialConfigurationGateDocument, options);
        }
// @ts-ignore
export function useApplyInitialConfigurationGateSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ApplyInitialConfigurationGateQuery, ApplyInitialConfigurationGateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ApplyInitialConfigurationGateQuery, ApplyInitialConfigurationGateQueryVariables>;
export function useApplyInitialConfigurationGateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApplyInitialConfigurationGateQuery, ApplyInitialConfigurationGateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ApplyInitialConfigurationGateQuery | undefined, ApplyInitialConfigurationGateQueryVariables>;
export function useApplyInitialConfigurationGateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApplyInitialConfigurationGateQuery, ApplyInitialConfigurationGateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ApplyInitialConfigurationGateQuery, ApplyInitialConfigurationGateQueryVariables>(ApplyInitialConfigurationGateDocument, options);
        }
export type ApplyInitialConfigurationGateQueryHookResult = ReturnType<typeof useApplyInitialConfigurationGateQuery>;
export type ApplyInitialConfigurationGateLazyQueryHookResult = ReturnType<typeof useApplyInitialConfigurationGateLazyQuery>;
export type ApplyInitialConfigurationGateSuspenseQueryHookResult = ReturnType<typeof useApplyInitialConfigurationGateSuspenseQuery>;
export type ApplyInitialConfigurationGateQueryResult = ApolloReactCommon.QueryResult<ApplyInitialConfigurationGateQuery, ApplyInitialConfigurationGateQueryVariables>;